import React from 'react';
import PropTypes from 'prop-types';
import './ProjectTypeCard.css';

const ProjectTypeCard = ({
  stepInfo,
  handleSelectCard,
  project_type: projectType,
}) => (
  <div className="col">
    <div className="row justify-content-center">
      {stepInfo.cards.map(card => (
        <div className="col-12 col-md-6 col-lg-4 mb-4 mb-lg-0" key={card.key}>
          <div
            className={`bg-white shadow-card p-5 text-center project-type-card--${card.key ===
              projectType && 'active'}`}
            onClick={() => handleSelectCard(card.key)}
          >
            <div className={`project-type-card-image--${card.key}`} />
            <p className="project-type-card-description mt-3">{card.text}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
);

ProjectTypeCard.propTypes = {
  stepInfo: PropTypes.object,
  handleSelectCard: PropTypes.func,
  project_type: PropTypes.string,
};

export default ProjectTypeCard;



// WEBPACK FOOTER //
// ./src/components/FreelancerPortfolio/ProjectTypeCard/ProjectTypeCard.js